'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var Highstock = new Class({
	Implements: [Events, Options],

	options: {
		colors: ['#6aade1', '#aca000', '#008c99', '#c03e62', '#494a66', '#ff6a00'],

		containerId: null,

		chart: {
			chart: {
				renderTo: 'chart_container'
			},

			rangeSelector: {
				selected: 5,

				inputStyle: {
					color: '#355672',
					// fontWeight: 'bold',
					fontSize: '13px'
				},

				inputDateFormat: '%m/%d/%Y',
				inputEditDateFormat: '%m/%d/%Y'
			},

			credits: {
				enabled: false
			},

			xAxis: {
				ordinal: false,
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14 //two weeks
			},

			yAxis: {
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: null
				},

				labels: {
					align: 'left',
					x: 0
				},

				min: 0,
				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				showLastLabel: true,
				opposite: false
			},

			navigator: {
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#008C99'
				}
			},

			plotOptions: {
				series: {
					animation: true
				},

				line: {
					dataGrouping: {
						enabled: false,
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			scrollbar: {
				barBackgroundColor: '#008C99',
				rifleColor: '#fff',
				buttonBackgroundColor: '#008C99',
				buttonArrowColor: '#fff'
			}
		},

		tooltip_title: null
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);

		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var x_label = this._element.getAttribute('data-x-label');
		var y_label = this._element.getAttribute('data-y-label');

		if (x_label && x_label.trim() != '') {
			this.options.chart.xAxis.title.text = x_label;
		}

		if (y_label && y_label.trim() != '') {
			this.options.chart.yAxis.title.text = y_label;
		}

		this._chart_options = document.getElements('.chart_options li');
		this._veil = this._element.getElement('.veil');

		var rpc;
		this.series_options = new Array(this._chart_options.length);

		if (this._chart_options) {
			this._chart_options.each(function (_el, i) {
				if (!_el.hasClass('disabled')) {
					_el.setStyles({
						'color': this.options.colors[i],
						'border-color': this.options.colors[i]
					});
				}
			}.bind(this));

			this.rpcs = [];
			this._chart_options.each(function (e) {
				this.rpcs.push(e.getAttribute('data-rpc'));
			}.bind(this));

			rpc = this.rpcs[0];

			this._chart_options.each(function (e, i) {
				if (!e.hasClass('disabled')) {
					e.addEvent('click', function () {
						if (!e.hasClass('selected')) {
							if (this.waiting) return;

							document.body.style.cursor = 'wait';
							var rpc = e.getAttribute('data-rpc');

							if (rpc && rpc !== '') {
								this.add_series_option(e, i);
							} else {
								this.show_warning();
							}
						} else {
							this.hide_series_option(i);

							e.setStyles({
								'color': this.options.colors[i],
								'background-color': '#fff'
							});
						}
					}.bind(this));
				} else {
					e.addClass('inactive');
				}
			}.bind(this));
		}

		rpc = rpc || this._element.getAttribute('data-rpc');

		if (rpc && rpc !== '') {
			this.rpc_request(rpc, this.post_rpc.bind(this));
		}
	},

	rpc_request: function rpc_request(url, success) {
		var self = this;

		if (this._veil) {
			this._veil.show();
		}

		this.remote = new Remote({
			rpc: url,
			method: 'get',
			onSuccess: success,
			onError: function onError() {
				self.show_warning(true);
			}
		});
	},

	show_warning: function show_warning(permanent_msg) {
		if (!this._err_msg) {
			this._err_msg = new Element('div', { 'class': 'err_msg', 'text': 'No data available. Please try again later.' });
			this._err_msg.inject(this._element, 'before');
		}

		this._err_msg.fade('in');

		if (!permanent_msg) {
			(function () {
				this._err_msg.fade('out');
			}).bind(this).delay(3000);
		}

		this.fireEvent('warning');
	},

	add_series_option: function add_series_option(option, i) {
		var name = option.get('text');

		if (!this.series_options[i]) {
			this.waiting = true;

			this.rpc_request(option.getAttribute('data-rpc'), function () {
				this.series_options[i] = {
					name: name,
					data: this.remote.get_data().data,
					color: this.options.colors[i]
				};

				if (this.chart) {
					this.chart.addSeries(this.series_options[i]);
				}

				option.setStyles({
					'color': '#fff',
					'background-color': this.options.colors[i]
				});

				option.addClass('selected');

				if (this._veil) {
					this._veil.hide();
				}

				this.waiting = false;
			}.bind(this));
		} else {
			this.chart.addSeries(this.series_options[i]);
			option.addClass('selected');

			option.setStyles({
				'color': '#fff',
				'background-color': this.options.colors[i]
			});

			if (this._veil) {
				this._veil.hide();
			}

			this.waiting = false;
		}

		document.body.style.cursor = 'default';
	},

	hide_series_option: function hide_series_option(i) {
		var name = this.series_options[i].name,
		    position;

		if (this.chart) {
			this.chart.series.each(function (e, i) {
				if (e.name === name) position = i;

				return;
			});

			this.chart.series[position].remove();
		}

		this._chart_options[i].removeClass('selected');
	},

	post_rpc: function post_rpc() {
		var data = this.remote.get_data();
		this.sales = this.remote.get_data().sales;

		if (data && data.data && this.remote.get_data().data.length > 1) {
			this.series_options[0] = {
				name: 'All Transactions',
				data: this.remote.get_data().data,
				color: this.options.colors[0]
			};

			if (this._chart_options) {
				this._chart_options[0].addClass('selected');

				this._chart_options[0].setStyles({
					'color': '#fff',
					'background-color': this.options.colors[0]
				});
			}

			this.create_chart();
		} else {
			this._chart_options.getParent().hide();
			this.show_warning(true);
		}

		if (this._veil) {
			this._veil.hide();
		}

		this.waiting = false;
	},

	create_chart: function create_chart() {
		var self = this;
		var series_options = this.series_options.clean();
		var chart_options = this.options.chart;
		var data_type = this.get_data_type();
		var _container = null;
		if (this.options.containerId) {
			_container = document.getElement('#' + this.options.containerId);
		} else {
			_container = document.getElement('.w_bldblimp #chart_container');
		}

		if (!_container) {
			_container = this._element.getElement('#chart_container');
		}

		this.move_rangeselector();

		chart_options = Object.merge(chart_options, {
			chart: {
				renderTo: _container
			},

			series: series_options,

			tooltip: {
				useHTML: true,
				style: {
					padding: '8px'
				},
				formatter: function formatter(e) {
					if (self.sales) {
						var data = self.sales[this.x];
						var content = '';
						var color = this.points[0].series.color;

						var counter = 0;
						Object.each(data, function (row, i) {
							content += row[0];
							if (counter < Object.getLength(data) - 1) {
								content += '<br /><hr style="margin: 10px 0; color: ' + color + ';" />';
							}
							counter++;
						});
					} else {
						var pageTitle = document.getElement('.page_title h1') ? document.getElement('.page_title h1').get('text') : '';
						var _title = self.options.tooltip_title || pageTitle;
						var total_points = this.points.length;
						var content = '';
						content += '<div class="series_name" style="border-bottom-color:' + this.points[0].series.color + '">' + _title + '</div><br/>' + 'Value on ' + '<b>' + Highcharts.dateFormat('%b %e, %Y', this.x) + '</b><br/><br/>';

						if (total_points > 1) {
							content += data_type + ' price / ft<sup>2</sup> of : <br/>';
						}

						this.points.each(function (e, i) {
							var point = e.point;
							var amount = e.point.series.options.data[e.point.index][2] ? ' (' + e.point.series.options.data[e.point.index][2] + ')' : '';

							if (total_points > 1) {
								content += '<span style="color:' + point.series.color + '; margin-left:20px;">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else if (self._element.getAttribute('data-price-type') == 'closing') {
								content += data_type + ' closing price of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							} else {
								content += data_type + ' price / ft<sup>2</sup> of <span style="color:' + point.series.color + '">' + point.series.name + amount + '</span>: <b>$' + Highcharts.numberFormat(e.y, 0) + '</b> <br/>';
							}
						});
					}

					return content;
				}
			},

			yAxis: {
				labels: {
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			}
		});

		this.chart = new Highcharts.StockChart(chart_options, function (chart) {
			setTimeout(function () {
				var _input_group = this._element.getElement('.highcharts-input-group');
				var _inputs = this._element.getElements('input.highcharts-range-selector', '#' + chart.options.chart.renderTo);

				if (_input_group) {
					// this is a workaround. close event from Date Picker widget is triggerred when clicking the input Date
					// need to cancel it.
					_input_group.addEvent('click', function (e) {
						e.stop();
					});
				}

				if (_inputs && _inputs.length > 1) {
					var min_date = new Date().parse(_inputs[0].get('value'));
					var max_date = new Date().parse(_inputs[1].get('value'));
				}

				_inputs.each(function (_el, i) {
					var min = min_date.clone();
					var max = max_date.clone();

					var dp = new Picker.Date(_el, {
						timePicker: true,
						draggable: false,
						minDate: i === 0 ? min : min.increment('day', 15),
						maxDate: i === 1 ? max : max.decrement('day', 15),
						pickOnly: 'days',
						pickerClass: 'datepicker_vista',
						format: "%Y-%m-%d",
						useFadeInOut: true,
						onSelect: function onSelect(dateText, input) {
							input.onchange();
							input.onblur();

							if (i === 0) {
								datepickers[1].options.minDate = dateText.increment('day', 15);
							} else if (i === 1) {
								datepickers[0].options.maxDate = dateText.decrement('day', 15);
							}
						}
					});

					datepickers.push(dp);

					_el.addEvent('focus', function () {
						datepickers.each(function (dp, j) {
							if (i !== j) {
								dp.hide();
							}
						});
					});
				});
			}.bind(this), 0);
		}.bind(this));
	},

	get_data_type: function get_data_type() {
		var rpc_string = this.remote.options.rpc;
		var p = rpc_string.contains('&p=');
		var show = rpc_string.contains('&show');

		if (p || show) {
			if (p) {
				data_type = 'Median';
			}

			if (show) {
				var rpc_string = this.remote.options.rpc;
				var start = rpc_string.indexOf('show');
				var end = rpc_string.lastIndexOf('&');
				var show_param = rpc_string.substring(start, end);
				var data_type = show_param.substring(show_param.indexOf('=') + 1);

				data_type = data_type == 'avg' ? 'Average' : 'Median';
			}

			return data_type;
		}

		data_type = 'Average';

		return data_type;
	},

	move_rangeselector: function move_rangeselector() {
		// To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 10
				});

				leftPosition += this.zoomText.getBBox().width + 20;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	}
});

var datepickers = [];
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var HighstockExt = new Class({
	Extends: Highstock,

	options: {
		series_name: '',
		clickable: true,
		colors: ['#78cff6', '#aca000', '#008c99', '#c03e62', '#494a66', '#ff6a00'],
		chart: {
			chart: {
				renderTo: 'chart_container',
				backgroundColor: '#ebebeb',
				marginRight: 20
			},

			rangeSelector: {
				selected: 5,
				inputEnabled: false,
				labelStyle: {
					color: '#666'
				},
				buttons: [{
					type: 'month',
					count: 6,
					text: '6m'
				}, {
					type: 'year',
					count: 1,
					text: '1yr'
				}, {
					type: 'year',
					count: 2,
					text: '2yr'
				}, {
					type: 'year',
					count: 4,
					text: '4yr'
				}, {
					type: 'year',
					count: 6,
					text: '6yr'
				}, {
					type: 'all',
					text: 'All'
				}],
				buttonTheme: {
					fill: 'none',
					stroke: 'none',
					style: {
						color: '#aaa'
					},
					states: {
						hover: {
							fill: 'white'
						},

						select: {
							fill: '#bbb',
							stroke: 'none',
							style: {
								color: '#fff'
							}
						}
					}
				}
			},

			credits: {
				enabled: false
			},

			xAxis: {
				ordinal: false,
				title: {
					text: null
				},
				minRange: 3600000 * 24 * 14, //two weeks
				labels: {
					style: {
						color: '#666'
					}
				}
			},

			yAxis: {
				plotLines: [{
					value: 0,
					width: 2,
					color: '666'
				}],

				title: {
					text: null,
					style: {
						color: '#666'
					}
				},

				labels: {
					style: {
						color: '#666'
					},
					y: -5,
					formatter: function formatter() {
						return '$' + this.value;
					}
				},

				gridLineDashStyle: 'dash',
				gridLineColor: '#666',
				endOnTick: false,
				showLastLabel: true,
				maxPadding: 0.06,
				opposite: false
			},

			navigator: {
				maskFill: 'rgba(150, 150, 150, 0.5)',
				xAxis: {
					tickInterval: 365 * 24 * 3600 * 1000,
					tickPixelInterval: 150,
					ordinal: false,
					dateTimeLabelFormats: {
						second: '%Y-%m-%d<br/>%H:%M:%S',
						minute: '%Y-%m-%d<br/>%H:%M',
						hour: '%Y-%m-%d<br/>%H:%M',
						day: '%Y<br/>%m-%d',
						week: '%Y<br/>%m-%d',
						month: '%Y-%m',
						year: '%Y'
					}
				},

				series: {
					color: '#bbb',
					lineWidth: 0
				}
			},

			plotOptions: {
				series: {
					// lineWidth: 4,
					animation: true,
					cursor: 'pointer'
				},

				line: {
					dataGrouping: {
						dateTimeLabelFormats: {
							day: ['%b %e, %Y', '%b %e', '%b %e, %Y'],
							week: ['%b %e, %Y', '%b %e', '%b %e, %Y']
						}
					}
				}
			},

			scrollbar: {
				enabled: true,
				barBackgroundColor: '#bbb',
				barBorderColor: '#fff',
				rifleColor: '#fff',
				buttonBackgroundColor: '#bbb',
				buttonArrowColor: '#666',
				buttonBorderColor: '#fff',
				trackBackgroundColor: '#bbb'
			}
		}
	},

	build: function build() {
		var x_label = this._element.getAttribute('data-x-label');
		var y_label = this._element.getAttribute('data-y-label');

		if (x_label && x_label.trim() != '') {
			this.options.chart.xAxis.title.text = this._element.getAttribute('data-x-label');
		}

		if (y_label && y_label.trim() != '') {
			this.options.chart.yAxis.title.text = this._element.getAttribute('data-y-label');
		}

		this._veil = this._element.getNext('.veil');

		var rpc = this.options.rpc || this._element.getAttribute('data-rpc');

		if (rpc && rpc != '') {
			this.rpc_request(rpc, this.post_rpc.bind(this));
		}

		this.series_options = [];

		this.series_options.push({
			name: this.options.series_name,
			color: this.options.colors[0]
		});
	},

	post_rpc: function post_rpc(options) {
		var self = this;
		var data = this.data || this.remote.get_data();

		if (options) {
			this.series_options[0].name = options.name;
			this.series_options[0].data = (options.data || data).data;
			if (this.options.clickable) {
				this.series_options[0].events = {
					click: function () {
						self.fireEvent('seriesClick');

						window.location = data.url;
					}.bind(this)
				};
			}
		} else {
			this.series_options[0].data = data.data;
			if (this.options.clickable) {
				this.series_options[0].events = {
					click: function () {
						self.fireEvent('seriesClick');

						window.location = data.url;
					}.bind(this)
				};
			}
		}

		datepickers.each(function (dp) {
			dp.hide();
		});

		if (this.series_options[0].data.length > 1) {
			if (this.chart) {
				this.chart.destroy();
				datepickers = [];
			}

			this.create_chart();
		} else {
			this._element.getParent().hide();
			this.show_warning(true);
		}

		if (this._veil) {
			this._veil.hide();
		}

		this.fireEvent('postRpc', [data]);
	},

	create_chart: function create_chart() {
		var self = this;
		var series_options = this.series_options.clean();
		var __date_difference = this.date_difference;

		this.move_rangeselector();

		var chart_options = this.options.chart;

		chart_options = Object.merge(chart_options, {
			series: series_options,

			tooltip: {
				useHTML: true,
				formatter: function formatter() {
					var details = '';

					this.points.each(function (e, i) {
						var point = e.point;
						var current = point.series.yData[point.series.yData.length - 1];
						var result = ((current - e.y.round()) / e.y.round() * 100).round(1);
						var sign = current >= Math.floor(e.y) ? '+' : '';
						result = sign + result.toString();

						var current_date = new Date();
						var from_date = new Date(Highcharts.dateFormat('%b %e, %Y', e.x));
						var xy = __date_difference(from_date, current_date);

						details += '<div class="series_name" style="border-bottom-color:' + point.series.color + '">' + point.series.name + '</div><br/>' + '<span>Current Price: <b>$' + Core.add_commas(current) + ' / ft<sup>2</sup></b></span><br/><br/>' + '<span style="color:#000">Price on ' + Highcharts.dateFormat('%b %e, %Y', e.x) + ': <b>$' + Core.add_commas(e.y) + ' / ft<sup>2</sup></b></span><br/>' + '<span>&nbsp; &nbsp; &nbsp;' + xy + ' year price change: ' + '<label style="color:' + (sign == '+' ? 'green' : 'red') + '"/>' + result.toString() + '%</label></span>';

						if (self.options.clickable) {
							details += '<br/><br/><span style="color:#000">Click for index details</span><br/><br/>';
						}
					});

					return details;
				}
			},
			yAxis: {
				labels: {
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			}
		});

		this.chart = new Highcharts.StockChart(chart_options, function (chart) {
			setTimeout(function () {
				var _input_group = this._element.getElement('.highcharts-input-group');
				var _inputs = this._element.getElements('input.highcharts-range-selector', '#' + chart.options.chart.renderTo);

				if (_input_group) {
					//this is a workaround. close event from Date Picker widget is triggerred when clicking the input Date
					//need to cancel it.
					_input_group.addEvent('click', function (e) {
						e.stop();
					});
				}

				if (_inputs && _inputs.length > 1) {
					var min_date = new Date().parse(_inputs[0].get('value'));
					var max_date = new Date().parse(_inputs[1].get('value'));
				}

				_inputs.each(function (_el, i) {
					var min = min_date.clone();
					var max = max_date.clone();

					var dp = new Picker.Date(_el, {
						timePicker: true,
						draggable: false,
						minDate: i === 0 ? min : min.increment('day', 15),
						maxDate: i === 1 ? max : max.decrement('day', 15),
						pickOnly: 'days',
						pickerClass: 'datepicker_vista',
						format: "%m/%d/%Y",
						useFadeInOut: true,
						onSelect: function onSelect(dateText, input) {
							input.onchange();
							input.onblur();

							if (i == 0) {
								datepickers[1].options.minDate = dateText.increment('day', 15);
							} else if (i == 1) {
								datepickers[0].options.maxDate = dateText.decrement('day', 15);
							}
						}
					});

					datepickers.push(dp);

					_el.addEvent('focus', function () {
						datepickers.each(function (dp, j) {
							if (i != j) {
								dp.hide();
							}
						});
					});
				});
			}.bind(this), 0);
		}.bind(this));
	},

	move_rangeselector: function move_rangeselector() {
		//To move the RangeSelector to the right of the graph
		Highcharts.RangeSelector.prototype.render = function (func) {
			return function () {
				func.apply(this, arguments);
				var leftPosition = this.chart.plotLeft,
				    topPosition = this.chart.plotTop - 18,
				    space = 2;

				this.zoomText.attr({
					x: leftPosition + 410,
					y: topPosition
				});

				leftPosition += this.zoomText.getBBox().width + 410;

				for (var i = 0; i < this.buttons.length; i++) {
					this.buttons[i].attr({
						x: leftPosition,
						y: topPosition - 14
					});
					leftPosition += this.buttons[i].width + space;
				}
			};
		}(Highcharts.RangeSelector.prototype.render);
	},

	date_difference: function date_difference(d1, d2) {
		var monthDay = [31, -1, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		var fromDate;
		var toDate;
		var year;
		var month;
		var day;

		fromDate = d1;
		toDate = d2;

		var increment = 0;

		if (fromDate.format('%e') > toDate.format('%e')) {
			increment = monthDay[fromDate.format('%m') - 1];
		}

		if (increment == -1) {
			if (fromDate.isLeapYear()) {
				increment = 29;
			} else {
				increment = 28;
			}
		}

		if (increment != 0) {
			increment = 1;
		}

		if (fromDate.get('Month') + increment > toDate.get('Month')) {
			month = toDate.get('Month') + 12 - (fromDate.get('Month') + increment);
			increment = 1;
		} else {
			month = toDate.get('Month') - (fromDate.get('Month') + increment);
			increment = 0;
		}

		year = toDate.get('year') - (fromDate.get('year') + increment);

		return year + '.' + month;
	},

	cancel_request: function cancel_request() {
		if (this.remote) {
			this.remote.cancel();
		}
	},

	rebuild_chart: function rebuild_chart(_el) {
		this.data = _el.data;

		if (_el.data) {
			this.post_rpc({
				name: _el.get('text'),
				data: this.data
			});
		} else if (_el.rpc) {
			this.series_options[0].name = _el.get('text');

			this.rpc_request(_el.rpc, function () {
				this.post_rpc({
					name: _el.get('text'),
					data: _el.data
				});
			}.bind(this));
		}
	}
});
'use strict';

Page.Mci = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		var _graph = document.getElement('.cityrealty_indices');

		if (!_graph) return;

		this.add_cityrealty_indices(_graph);
	},
	add_cityrealty_indices: function add_cityrealty_indices(_cont) {
		var _cityrealty_indices = _cont;

		if (!_cityrealty_indices) return;

		var _details = _cityrealty_indices.getElement('.indices_details');
		var _price = _details.getElement('.price');
		var _button = _details.getElement('a.button');
		var _periods = _details.getElements('li');
		var _title = _cityrealty_indices.getElement('.ci_header');
		var _description = _cityrealty_indices.getElement('.ci_description');

		var prices;
		var files = 16; //amount of pngs with different graphs
		var in_process = false;
		var highstock;

		if (_title) {
			_title.init_text = _title.get('text');
		}

		var __randomise_graphs = function __randomise_graphs() {
			var _poss = _details.getElements('._positive');
			var _negs = _details.getElements('._negative');

			if (!_poss && !_negs) return;

			var prices_abs = [];

			prices.each(function (p) {
				prices_abs.push(Math.abs(p));
			});

			var max = Math.max.apply(null, prices_abs);

			var range = Math.floor(files / (_poss.length + _negs.length));

			var taken = [];

			prices.each(function (p, i) {
				var percent = Math.abs(p) * 100 / max;

				if (p != 0) {
					var _change = _periods[i].getElement('.graph').setProperty('class', 'graph');
					var num = Math.round(files * percent / 100);

					while (taken.contains(num)) {
						var random = Math.floor(Math.random() * range);

						if (num + random < 16) {
							num += random;
						} else {
							num -= random;
						}

						num = Math.min(16, num);
						num = Math.max(1, num);
					}

					_change.addClass((p < 0 ? 'neg_' : '_') + num);

					taken.push(num);
				}
			});
		};

		var __update_details = function __update_details(_el, price_change) {
			_description.set('html', _el.getAttribute('data-description'));
			_price.set('html', _el.getAttribute('data-avg_ppsqft'));
			_button.setAttribute('href', _el.getAttribute('data-href'));

			prices = [price_change[3] || 0, price_change[6] || 0, price_change[12] || 0, price_change[24] || 0];

			_periods.each(function (_el, i) {
				var _change = _el.getElement('.change');
				var value = prices[i] > 0 ? '+' : prices[i] < 0 ? '-' : '';

				_change.set('text', (value == '+' ? value : '') + prices[i].toFixed(1) + '%');

				var cls = value == '+' ? '_positive' : value == '-' ? '_negative' : '';

				_el.setProperty('class', '');
				_el.addClass(cls);

				var _graph = _el.getElement('.graph').setProperty('class', 'graph');

				if (prices[i] == 0) {
					var random = Math.floor(Math.random() * 4);
					var cls = '_0';

					for (var i = 0; i <= random; i++) {
						cls += 0;
					}

					_graph.addClass(cls);
				}
			});

			__randomise_graphs();

			if (_title) {
				_title.set('text', _title.init_text + ' ' + _el.get('text'));
			}
		};

		var _controllers = _cityrealty_indices.getElement('.indices_categories');
		_controllers.addClass('loading');

		var _categories = _controllers.getElements('li a');
		var _selected_category;
		var _category;
		var _selectedIndex = null;

		_categories.each(function (_el, idx) {
			_el.rpc = _el.getAttribute('data-rpc');

			if (_el.getAttribute('data-selected')) {
				_selectedIndex = _el.getAttribute('data-index');
			}

			_el.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (in_process) {
					highstock.cancel_request();
					in_process = false;
				}

				if (_el != _selected_category) {
					in_process = true;

					if (_selected_category) {
						_selected_category.removeClass('_selected');
					}

					_el.addClass('_selected');
					_selected_category = _el;

					if (highstock) {
						highstock.rebuild_chart(_el);
					}
				}
			});
		});

		var index = 3;
		if (_selectedIndex) {
			index = _selectedIndex;
		} else if (location.hash) {
			var hash = location.hash.replace('#', '');
			index = hash;
		}

		_categories.each(function (_el) {
			if (_el.getAttribute('data-index') == index) {
				_category = _el;
				return false;
			}
		});
		_category.fireEvent('click');

		var _highstock = _cityrealty_indices.getElement('#chart_container');
		_highstock.setAttribute('data-rpc', _category.getAttribute('data-rpc'));

		highstock = new HighstockExt(_highstock, {
			series_name: _category.get('text'),
			onPostRpc: function onPostRpc(data) {
				in_process = false;

				if (!_selected_category.data) {
					_selected_category.data = data;
				}

				__update_details(_selected_category, data.change);
			}
		});
	}
});
//# sourceMappingURL=mci.js.map
